export const RESET_PASSWORD = '@@FORGOT_PASSWORD/RESET_PASSWORD';
export const SAVE_ERROR_REPONSE_RESET_PASSWORD = '@@FORGOT_PASSWORD/SAVE_ERROR_REPONSE';

export const actionCreators = {
    resetPassword: (payload) => ({
        type: RESET_PASSWORD, 
        payload
    }), 
    saveErrorReponse: (payload) => ({
        type: SAVE_ERROR_REPONSE_RESET_PASSWORD, 
        payload
    }), 

};
